import styled from 'styled-components';
import ColorSF2 from './ColorSF2';

const Title = styled.div`
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background-color: ${ColorSF2.paleBlue};
  font-weight: bold;
  width: 100%;
  height: 50px;
  padding: 0 15px;
  @media (max-width: 830px), (max-height: 530px) {
    height: 30px;
  }
`;

export default Title;
